<script setup>
import { useColorClass } from '@/composables/getColorClass';

defineProps({
  icon: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    required: true,
  },
});
</script>
<template>
  <div
    class="absolute top-[-29px] flex items-center justify-center left-1/2 -translate-x-1/2 z-10"
  >
    <div
      class="border-2 border-neutral-300 rounded-full bg-neutral-100 flex items-center pl-2 pr-3"
      :style="{ height: '62px' }"
    >
      <div
        class="rounded-full w-12 h-12 flex items-center justify-center mr-2"
        :class="useColorClass(color).bg"
      >
        <fa-icon :icon="icon" class="text-neutral-0 text-2xl" />
      </div>

      <p class="h700">{{ name }}</p>
    </div>
  </div>
</template>
